import { localPreferences } from 'app-components/utils/core';
import React from 'react';

/////////////////////////////////////////////
if (localPreferences.getWhyDidYouRender()) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render'); // eslint-disable-line global-require
  const ReactRedux = require('react-redux'); // eslint-disable-line global-require
  const { virtualIncludeAll, ...localWDYRSettings } = localPreferences.getWDYRSettings();

  const wdyrSettings = {
    ...localWDYRSettings,
    ...(virtualIncludeAll && { include: [/.*/] }),
    trackExtraHooks: [[ReactRedux, 'useSelector']],
    // hotReloadBufferMs: 500,
    // include: [
    //   /.*/,
    // ],
    // exclude: [
    //   /.*/,
    // ],
    // titleColor
    // diffNameColor
    // diffPathColor
  };
  whyDidYouRender(React, wdyrSettings);
}
/////////
